import { getSketchData } from './getSketchData';

export const getMatchSketches = (selectedMod, vendoCode) => {
  return selectedMod.sketches
    .filter(sketch => getSketchData(sketch.image_original_name).matchCode.includes(vendoCode))
    .map(sketch => sketch.image);
};
